import axios from 'axios';
import { eventBus } from '@/utils/event';

const instance = axios.create({
  timeout: 30000,
  headers: {
  	'M-Device-Type': 'mobile_web',
  	'M-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone
  }
});

export function network(opts) {
	const { method, params = {}, url, headers = {} } = opts;
	
	if (method === 'post') {
		return new Promise((resolve, reject) => {
			instance.post(url, {
			  ...params
			}, {
				headers
			}).then((res) => {
				const body = res.data;

				if (body.code === 10001) {
					eventBus.$emit('relogin');
				}

				resolve(body);
			}).catch((err) => {
				if (err.response && err.response.status === 401) {
					reject({
						code: 1000,
						message: '登录过期，请重新登录'
					});
					eventBus.$emit('relogin');
					return;
				}

				if (err.response && err.response.status === 403) {
					reject({
						code: 1001,
						message: '无权限'
					});
					return;
				}

				if (err.response) {
					reject({
						code: 1002,
						message: err.response.statusText
					});
				}
				else {
					reject({
						code: 1002,
						message: err.message
					});
				}
			});
		});
	}

	if (method === 'get') {
		return new Promise((resolve, reject) => {
			instance.get(url, {
			  params,
			  headers
			}).then((res) => {
				const body = res.data;

				if (body.code === 10001) {
					eventBus.$emit('relogin');
				}

				resolve(body);
			}).catch((err) => {
				if (err.response && err.response.status === 401) {
					reject({
						code: 1000,
						message: '登录过期，请重新登录'
					});
					eventBus.$emit('relogin');
					return;
				}

				if (err.response && err.response.status === 403) {
					reject({
						code: 1001,
						message: '无权限'
					});
					return;
				}

				if (err.response) {
					reject({
						code: 1002,
						message: err.response.statusText
					});
				}
				else {
					reject({
						code: 1002,
						message: err.message
					});
				}
			});
		});
	}
}
